export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Pending"] = "Pending";
    PaymentStatus["Failed"] = "Failed";
    PaymentStatus["Succeeded"] = "Succeeded";
})(PaymentStatus || (PaymentStatus = {}));
//# sourceMappingURL=PaymentStatus.js.map